import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import PWAInstallPrompt from "@/components/PWAInstallPrompt";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import VerifyEmail from "@/pages/VerifyEmail";
import SetupOrganization from "@/pages/SetupOrganization";
import AcceptInvite from "@/pages/AcceptInvite";
import Profile from "@/pages/Profile";
import MyRole from "@/pages/MyRole";
import SwitchOrganization from "@/pages/SwitchOrganization";
import OrganizationSettings from "@/pages/OrganizationSettings";
import AccountBilling from "@/pages/AccountBilling";
import HelpSupport from "@/pages/HelpSupport";
import Index from "@/pages/Index";
import WeddingDetail from "@/pages/WeddingDetail";
import PublicInvite from "@/pages/PublicInvite";
import PublicRsvp from "@/pages/PublicRsvp";
import NotFound from "@/pages/NotFound";
import { checkAndClearCache } from "@/utils/cache";
import "@/App.css";

function App() {
  // Check cache version on app mount
  useEffect(() => {
    checkAndClearCache();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/accept-invite" element={<AcceptInvite />} />
            <Route path="/invite/:shareToken" element={<PublicInvite />} />
            <Route path="/rsvp/:token" element={<PublicRsvp />} />
            
            {/* Protected routes (auth required, no org required) */}
            <Route path="/setup-organization" element={
              <ProtectedRoute requireOrg={false}>
                <SetupOrganization />
              </ProtectedRoute>
            } />
            
            {/* Protected routes (auth + org required) */}
            <Route path="/" element={
              <ProtectedRoute>
                <Index />
              </ProtectedRoute>
            } />
            <Route path="/wedding/:id" element={
              <ProtectedRoute>
                <WeddingDetail />
              </ProtectedRoute>
            } />
            
            {/* Profile & Account routes */}
            <Route path="/profile" element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            } />
            <Route path="/my-role" element={
              <ProtectedRoute>
                <MyRole />
              </ProtectedRoute>
            } />
            <Route path="/switch-organization" element={
              <ProtectedRoute requireOrg={false}>
                <SwitchOrganization />
              </ProtectedRoute>
            } />
            
            {/* Organization Management routes */}
            <Route path="/organization/settings" element={
              <ProtectedRoute>
                <OrganizationSettings />
              </ProtectedRoute>
            } />
            <Route path="/organization/team" element={
              <ProtectedRoute>
                <OrganizationSettings />
              </ProtectedRoute>
            } />
            <Route path="/account-billing" element={
              <ProtectedRoute>
                <AccountBilling />
              </ProtectedRoute>
            } />
            
            {/* Help & Support */}
            <Route path="/help" element={
              <ProtectedRoute>
                <HelpSupport />
              </ProtectedRoute>
            } />
            
            {/* 404 */}
            <Route path="*" element={<NotFound />} />
          </Routes>
          <Toaster />
          <PWAInstallPrompt />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;